import { initializeApp } from 'firebase/app';
import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { getCookiePreferences } from './utils/cookiePreferences';

// Firebase config from .env (REACT_APP_FIREBASE_*)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const hasRequiredConfig = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId
);

let app = null;
let analytics = null;

// Analytics is optional. Missing env vars must not crash the marketing site.
if (hasRequiredConfig) {
  try {
    app = initializeApp(firebaseConfig);
    if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
      analytics = getAnalytics(app);
      setAnalyticsCollectionEnabled(analytics, getCookiePreferences().performance);
    }
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Firebase init skipped', error);
    }
    app = null;
    analytics = null;
  }
}

export { app, analytics };
